import { router } from "@inertiajs/react"
import { Plus } from "lucide-react"
import { useEffect, useRef, useState } from "react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useSidebar } from "@/components/ui/sidebar"
import {
  newAdminAccountPath,
  newAdminAgentPath,
  newAdminPartnerPath,
  newAdminPartnerUserPath,
  newAdminUserPath,
} from "@/routes"

type RecordType =
  | "account"
  | "client_user"
  | "partner_user"
  | "custom_agent"
  | "partner"

export function AdminRecordLauncher() {
  const [open, setOpen] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)
  const { state } = useSidebar()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault()
        setOpen(true)
      }
    }

    document.addEventListener("keydown", handleKeyDown)
    return () => document.removeEventListener("keydown", handleKeyDown)
  }, [])

  const handleSelect = (type: RecordType) => {
    switch (type) {
      case "account":
        router.visit(newAdminAccountPath())
        break
      case "client_user":
        router.visit(newAdminUserPath())
        break
      case "partner_user":
        router.visit(newAdminPartnerUserPath())
        break
      case "custom_agent":
        router.visit(newAdminAgentPath())
        break
      case "partner":
        router.visit(newAdminPartnerPath())
        break
    }
  }

  return (
    <div className="px-2">
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            ref={triggerRef}
            variant="default"
            className="my-2 flex w-full items-center justify-items-center gap-2"
          >
            <Plus className="size-4" />
            {state === "expanded" && <span>Create new</span>}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56">
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSelect("partner")}
          >
            Partner
          </DropdownMenuItem>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSelect("account")}
          >
            Account
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSelect("client_user")}
          >
            Client user
          </DropdownMenuItem>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSelect("partner_user")}
          >
            Partner user
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => handleSelect("custom_agent")}
          >
            Custom agent
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
